import { exportsModule } from '@cian/mf-registry/browser';
import { createDesktopFiltersConstructor } from '../services/WebComponent';
import { createApplicationState } from '../services/applicationState';
import { createApplicationContext } from '../services/applicationContext';
import { MICROFRONTEND_PATH } from 'shared/constants/microfrontend';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);
  const customElementConstructor = createDesktopFiltersConstructor(context, store);

  exportsModule({
    ui: {
      [MICROFRONTEND_PATH.v1]: customElementConstructor,
    },
  });
}
